import { Component, EventEmitter, Output } from '@angular/core';

interface BonusTier {
  amountKey: string;
  bonusKey: string;
}

@Component({
  selector: 'app-bonus-reward',
  standalone: false,
  templateUrl: './bonus-reward.component.html',
  styleUrl: './bonus-reward.component.scss',
})
export class BonusRewardComponent {
  @Output() closed = new EventEmitter<void>();

  readonly tiers: BonusTier[] = [1, 2, 3, 4, 5].map((tier) => ({
    amountKey: `bonus_reward.tier_${tier}_amount`,
    bonusKey: `bonus_reward.tier_${tier}_bonus`,
  }));

  onClose(): void {
    this.closed.emit();
  }
}
